// extracted by mini-css-extract-plugin
export default {"dropdown":"components-general-smart-insights-detail-view-dropdown-archive-module__dropdown"};